import React, { useContext } from 'react'

import { DataContext } from '../../context/DataContext'

interface LoaderProps {
  small?: boolean
}

const Loader: React.FC<LoaderProps> = ({ small = false }: LoaderProps) => {
  const { companyColor } = useContext(DataContext)

  const companyColorWithOpacity = `${companyColor}33`
  const companyColorWithOpacity2 = `${companyColor}CC`
  const companyColorWithOpacity3 = companyColor

  return (
    <div className="flex items-center justify-center">
      <div
        className={`${small ? 'h-12 w-12' : 'h-[70px] w-[70px]'} rounded-full animate-spin`}
        style={{
          background: `
            conic-gradient(
              from 0deg,
              transparent 30%,
              ${companyColorWithOpacity} 50%,
              ${companyColorWithOpacity2} 70%,
              ${companyColorWithOpacity3} 90%,
              ${companyColorWithOpacity3} 100%
            )
          `,
          mask: 'radial-gradient(farthest-side, transparent 85%, black 86%)',
          WebkitMask:
            'radial-gradient(farthest-side, transparent 85%, black 86%)'
        }}
        data-testid="loader"
      />
    </div>
  )
}

export default Loader
